/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Beides17Inputs */

const en__field_enum_csjensblank_beides17 = /** @type {(inputs: _Field_Enum_Csjensblank_Beides17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const de__field_enum_csjensblank_beides17 = /** @type {(inputs: _Field_Enum_Csjensblank_Beides17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beides`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {_Field_Enum_Csjensblank_Beides17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_beides17 = /** @type {((inputs?: _Field_Enum_Csjensblank_Beides17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Beides17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_beides17(inputs)
	return de__field_enum_csjensblank_beides17(inputs)
});
export { _field_enum_csjensblank_beides17 as "_field_enum_CSJENSBLANK_BEIDES" }